import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Player, Controls } from '@lottiefiles/react-lottie-player';

import { HiOutlineLightningBolt } from 'react-icons/hi';
import { ClassContainer } from './styles';
import CardsModal from '../../../../../../components/CardsModal';
import Cards from './dataComponents';
import { useToast } from '../../../../../../hooks/toast';

const Components: React.FC = () => {
  const { t } = useTranslation();

  const { addToast } = useToast();

  const [showNextButton, setShowNextButton] = useState(false);

  useEffect(() => {
    if (showNextButton === true) {
      addToast({
        type: 'success',
        label: t("Now we're talking!"),
        description: t("Click on the 'next' button to continue!"),
      });
    }
  }, [addToast, showNextButton, t]);

  return (
    <ClassContainer showNextButton={showNextButton}>
      <h1>{t('Components')}</h1>
      <Player
        autoplay
        loop
        src="https://learnfirst-bucket.s3.amazonaws.com/frc/bulb.json"
        style={{ height: '250px', width: '250px', margin: '1rem 0' }}
      >
        <Controls visible={false} />
      </Player>
      <p>
        {t(
          'FRC robots are equipped with a variety of electrical components that play vital roles in their operation. These components are designed to provide power, control, and communication to the different systems of the robot during competitions.',
        )}
      </p>
      <p>
        {t("Now, let's get to know some of these components of our robot.")}
      </p>
      <p className="modalStartText">{t('Click the button below to start:')}</p>
      <CardsModal
        Icon={HiOutlineLightningBolt}
        bgColor="#ffb129"
        propBorderColor="#f2d4a0"
        setShowNextButton={setShowNextButton}
        cards={Cards}
      />
    </ClassContainer>
  );
};

export default Components;
